
import { getUserInfo, isWeiXin, system, isApp, shareFun } from '@/util/const'
import  LoginWindow from './LoginWindow';
import  BoxWindow from './BoxWindow';
import {getQueryVariable } from '@/util/const'
import { setAuthorization } from '../../axios/userInfo'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'

import defaultImg from '../../../static/img/birthday/life_jk_phb_touxiang_a@2x.png'
import { Base64 } from 'js-base64'

export default {
components: {
'LoginWindow': LoginWindow,
'BoxWindow': BoxWindow,
Flexbox,
FlexboxItem,
},
data () {
return {
defaultImg,
userInfo:'',
lang: window.localStorage.getItem('lang'),
openInBrowser: false,
status: false,
phoneNumber: '',
loginShow: false,
send:0,
user:[],
flag: 0,
sendUser:0,
init:0,
boxShow:false,
tagHref: {
series_update: 'openpage://3520',
recommend_update: 'openpage://8600'
},
bg: this.$t('birthday.bg'),
resultType: 2,
isIos: system(),
isWeiXin: isWeiXin(),

}
},
created () {
if (isApp()) {
getUserInfo({ callbackName: 'getUserInfo', needLogin: true })
} else {
if (process.env.NODE_ENV === 'development') {
setAuthorization('e998e1d1-e70b-4ce1-88c5-cb80225786c4')
this.getData()
}
}

window.getUserInfo = (obj) => {
if (obj) {
setAuthorization(obj.authorization)
this.phoneNumber = obj.user.phone
this.getData()
if (obj.boss) {
} else {
}
}
}
const shareObj = {
type: 2,
buttonText: this.$t('birthday.birthday33'),
url: `${window.location.protocol}//${window.location.host}${window.location.pathname}#/rule`
}
shareFun(shareObj)
},
mounted () {

},
methods: {
getData() {
this.$http.get(`/ticket_racing/birthdaygift/ticketCount`, { phone: this.phoneNumber }).then(res => {
if(res.data.body.records){
this.user = res.data.body.records
}else {
this.flag = 1
}
this.init = res.data.body.count
this.send = 3-res.data.body.count
})
},
receive() {
let param = this.phoneNumber
param = Base64.encode(param)
console.log('this.send',window.localStorage.getItem('lang'))
let _href = `${location.origin}${location.pathname}#/birthdaysend/${param}?lang=${window.localStorage.getItem('lang')}`
let content = encodeURIComponent(this.$t('birthday.birthday54'))
let title = encodeURIComponent(this.$t('birthday.birthday56'))
let img = `https://mylink.oss-accelerate.aliyuncs.com/mylinkH5/shareLogo/shareLogo`
let url = `cmcchkhsh://openshare?url=${encodeURIComponent(_href)}&title=${title}&content=${content}&img=${img}&type=`
window.location.href = url
}
}
}



// WEBPACK FOOTER //
// ./src/page/birthday/birthdayshare.vue